import GetImage from '../../components/getimage/Getimage';
import { StatusComponent } from './StatusComponent';
import { getMeetingDay } from './utility/getMeetingDay';
import getMeetingTime from './utility/getMeetingTime';
import meetingmom from "../../assets/document.png"
import attendees from "../../assets/teammeeting.png"
import './meetinglist.css'
const Meetinglist = ({list,GetMeetingDetails,meetingid}) => {
        
  return (
    <div>
        {list && (
          <div className='meetingscroll' >
            {
              list?.length > 0 ? <div>
                {
                  list?.map((item,index)=>{
return(
  <div onClick={()=>GetMeetingDetails(item?.meetingid)} key={item?.meetingid} className={`meetingtile meeting-item ${meetingid == item?.meetingid ? 'activemeeting' : ''}`}  
          style={{ animationDelay: `${index * 0.1}s` }}>
    <div style={{display:"flex" , justifyContent:"space-between" , alignItems:"center", marginBottom:"10px"}}>
      <p style={{marginBottom:"0px"}} className='scheduledmeeting'><StatusComponent data={item}/></p>
      <p style={{marginBottom:"0px"}} className='todaymeeting'>{getMeetingDay(item?.scheduledtime?.date)}</p>
      </div>
      <div className='leftsec'>
         <div className='imagesection'>
        <div>
          <GetImage key={item?.hostempid} imgID={item?.hostempid} width='45px' height='45px'/>
          </div>
          <div>
            <p style={{marginBottom:"0px"}} className='meetingddescription'>{item?.name}</p>
            <div className='timemeeting'>
            <span>{getMeetingTime(item?.scheduledtime?.date)}</span> - <span>{getMeetingTime(item?.endtime?.date)}</span>
              </div>
          </div>
      </div>

      <div className='attendeesmom'>
        {
          item.hasmom != 0 ? <img src={meetingmom} className='img-fluid meetinggroupimg'/> : ""
        }
        {
          item?.attendees ? <img src={attendees} className='img-fluid meetinggroupimg'/> : ""
        }
        <p style={{marginBottom:"0px",fontWeight:"600"}} className='todaymeeting'>
{
          item?.attendees
        }
        </p>
        
        </div>
        </div>
    </div>
)
                  })
                }
                </div>  : ""
            }
          </div>
        )}
    </div>
  );
};
export default Meetinglist;